import React from 'react';
import { Rect } from 'react-konva';
import { BoxCanvasConfig } from 'utils/annotations/point';

export const Box: React.FC<BoxCanvasConfig> = ({ color, size = 5, stroke = 'white', strokeWidth = 1, ...props }) => (
  <Rect width={size} height={size} fill={color} stroke={stroke} strokeWidth={strokeWidth} {...props} />
);
